"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerDefaultFontFaces = exports.DefaultFontStyles = void 0;
var theme_1 = require("@fluentui/theme");
Object.defineProperty(exports, "DefaultFontStyles", { enumerable: true, get: function () { return theme_1.DefaultFontStyles; } });
Object.defineProperty(exports, "registerDefaultFontFaces", { enumerable: true, get: function () { return theme_1.registerDefaultFontFaces; } });
//# sourceMappingURL=DefaultFontStyles.js.map